import { Stack, Switch, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { useId } from 'react';

interface SwitchProps {
  toggle: boolean;
  setToggle: (toggle: boolean) => void;
  text: string;
  justifyContent?: 'space-between' | 'inherit';
}

export const ToggleSwitch = ({
  toggle,
  setToggle,
  text,
  justifyContent = 'inherit',
}: SwitchProps) => {
  const switchId = useId();
  return (
    <Stack flexDirection="row" alignItems="center" justifyContent={justifyContent}>
      <Typography
        component="label"
        htmlFor={switchId}
        pr={1}
        variant="subtitle2"
        color="text.secondary"
        noWrap
      >
        {text}
      </Typography>
      <Switch
        id={switchId}
        value={toggle}
        checked={toggle}
        onClick={() => setToggle(!toggle)}
        sx={(theme) => {
          const palette = theme.vars.palette;
          return {
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: palette.primary.main,
              '& + .MuiSwitch-track': {
                backgroundColor: palette.primary.light,
                opacity: 1,
              },
              '&:hover': {
                backgroundColor: theme.vars
                  ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.08)`
                  : alpha(theme.palette.primary.main, 0.08),
              },
            },
          };
        }}
      />
    </Stack>
  );
};
